webpackJsonp([19],{

/***/ "U4kt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/common/404.vue
//
//
//
//
//
//
//

/* harmony default export */ var _04 = ({
    data: function data() {
        return {
            left: 5,
            timer: null
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.timer = setInterval(function () {
            _this.left--;

            if (_this.left == 0) {
                _this.$router.replace({ path: '/' });
            }
        }, 1000);
    },

    methods: {
        back: function back() {
            clearInterval(this.timer);
            this.$router.go(-1);
        }
    },
    beforeDestroy: function beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02254b29","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/common/404.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spec-page-container"},[_c('img',{attrs:{"src":"http://cdn.wxhand.com/amb/images/404.png","alt":""}}),_vm._v(" "),_c('p',{staticClass:"content"},[_vm._v("很遗憾，您访问的的页面挖不到啦！"),_c('br'),_c('span',{staticClass:"blue"},[_vm._v(_vm._s(_vm.left)+"s")]),_vm._v(" 后返回主页，您也可以"),_c('router-link',{staticClass:"blue",attrs:{"to":{path: '/'},"replace":""}},[_vm._v("手动跳转")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var common_404 = (esExports);
// CONCATENATED MODULE: ./src/view/common/404.vue
function injectStyle (ssrContext) {
  __webpack_require__("mPzT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02254b29"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  _04,
  common_404,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var view_common_404 = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "fDny":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, ".spec-page-container[data-v-02254b29]{position:absolute;top:220px;bottom:0;width:100%;max-width:1561px;min-height:500px;background:url(http://cdn.wxhand.com/amb/images/404_bg.png) bottom no-repeat;background-size:auto 100%;text-align:center}.content[data-v-02254b29]{display:block;margin-top:20px;line-height:1.5;color:#555}img[data-v-02254b29]{width:230px}.blue[data-v-02254b29]{color:#20a0ff}", "", {"version":3,"sources":["/Users/wilbur/code/amb2.wxhand.com/manager-system/src/view/common/404.vue"],"names":[],"mappings":"AACA,sCACE,kBAAmB,AACnB,UAAW,AACX,SAAU,AACV,WAAY,AACZ,iBAAkB,AAClB,iBAAkB,AAClB,6EAAqF,AACrF,0BAA2B,AAC3B,iBAAmB,CACpB,AACD,0BACE,cAAe,AACf,gBAAiB,AACjB,gBAAiB,AACjB,UAAY,CACb,AACD,qBACE,WAAa,CACd,AACD,uBACE,aAAe,CAChB","file":"404.vue","sourcesContent":["\n.spec-page-container[data-v-02254b29] {\n  position: absolute;\n  top: 220px;\n  bottom: 0;\n  width: 100%;\n  max-width: 1561px;\n  min-height: 500px;\n  background: url(http://cdn.wxhand.com/amb/images/404_bg.png) bottom center no-repeat;\n  background-size: auto 100%;\n  text-align: center;\n}\n.content[data-v-02254b29] {\n  display: block;\n  margin-top: 20px;\n  line-height: 1.5;\n  color: #555;\n}\nimg[data-v-02254b29] {\n  width: 230px;\n}\n.blue[data-v-02254b29] {\n  color: #20a0ff;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "mPzT":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("fDny");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("30d81ace", content, true);

/***/ })

});


// WEBPACK FOOTER //
// static/js/19.c9622f41d26ab4bccf5e.js